<template>
    <div class=" w-100 badge px-2" :style="{'background-color': bg_color}" >
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'CBadge',
    props:{
        bg_color : String,
    }
}
</script>